import React from "react";
import logger from "logger";
import AngCheckbox from "Common/Angular/AngCheckbox";

const items = [
  "The Necromancer",
  "Clearing the High Trail",
  "Avenging Durom",
  "Through Mirewood",
];

const exists = function(item, list) {
  return list.indexOf(item) > -1;
};

const toggle = function(item, list) {
  var idx = list.indexOf(item);
  if (idx > -1) {
    list.splice(idx, 1);
  } else {
    list.push(item);
  }
};

export default function(props) {
  const { label, AccountDetailData, taskConfig, setValue, param } = props;

  const isChecked = () => {
    return taskConfig[param].length === items.length;
  };

  const areAllChecked = isChecked();

  const toggleAll = function() {
    let value = [...taskConfig[param]];
    if (areAllChecked) {
      value = [];
    } else {
      value = [...items];
    }
    setValue({ target: { value } }, param);
  };

  return (
    <div layout="row" layout-wrap>
      <div flex="100" layout="column">
        <div>
          <fieldset className="demo-fieldset">
            <legend className="demo-legend">Select Maps:</legend>
            <div layout="row" layout-wrap flex>
              <div flex-xs flex="50">
                <AngCheckbox value={areAllChecked} onChange={toggleAll}>
                  {areAllChecked === true && (
                    <span>Un-</span>
                  )}
                  Select All
                </AngCheckbox>
              </div>
              {items.map((item) => {
                return (
                  <div className="demo-select-all-checkboxes" flex="100">
                    <AngCheckbox
                      value={exists(item, taskConfig[param])}
                      onChange={() => {
                        var value = [...taskConfig[param]];
                        toggle(item, value);
                        setValue({ target: { value } }, param);
                      }}
                    >
                      {item}
                    </AngCheckbox>
                  </div>
                );
              })}
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
}
